import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bfe94350"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "page-title pt-4" }, "Cacher un produit pour une société cliente", -1))

import { useRoute } from 'vue-router';
import CustomButton from "@/components/forms/CustomButton.vue";
import HideProduct from "@/components/product/masterProduct/hide/HideProduct.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'HiddenMasterProductByCompanyDetail',
  setup(__props) {

const route = useRoute();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(CustomButton, {
      to: {
            name: 'hiddenMasterProductByCompanyList', 
            params: { uuid: _unref(route).params.uuid }
        },
      label: "Links.goBack"
    }, null, 8, ["to"]),
    _hoisted_1,
    _createVNode(HideProduct)
  ], 64))
}
}

})